import React, { Component, Fragment } from "react";
import moment from "moment";

//services
import { UtilityService } from "../../services";

class PrintDevelopmentTrim extends Component {
  state = {
    trim: {}
  };

  componentWillMount() {
    this.setState({
      trim: this.props.trim
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.trim != this.props.trim) {
      this.setState({
        trim: nextProps.trim
      });
    }
  }

  render() {
    const { trim } = this.state;
    const { fullPackageData, jobWorkData } = trim;

    return (
      <Fragment>
        <div className="fabricPrintDiv">
          <style>
            {`@media print {
              body{
                  font-family: 'Montserrat', sans-serif;
                  font-size:12px;
              }
              .fontSize12{
                  font-size:12px;
              }
              .fabricPrintDiv{
                border : 2px solid black;
                top : 0;
                bottom : 0;
              }

              .printrow {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                width: 100%;
              }

              .printcolumn {
                display: flex;
                flex-direction: column;
                flex-basis: 100%;
                flex: 1;
              }
              .box-item {
                border-right: 1px solid black;
                padding-right: 10px;
              }
              .box-item:last-child {
                border-right: none;
              }
              table>tbody>tr td{
                  font-size:12px;
              }
              .label-text{
                  color:#279588;
                  font-size : 12px;
                  font-weight:bold;
              }
              .blue{
                  color : #146FF9;
              }
              .padding-for-heading{
                padding: 5px;
              }


               .specialComments{
                  width: 100%;
                  border : 1px solid black;
                  min-height : 60px;
                  margin: 10px;
                  padding: 10px!important;
              }

              .b{
                  border: 1px solid black;
                  margin: 10px;
                  padding: 5px;
              }
              .fabric-text{
                font-size:16px;
                color: #279588;
                font-weight: 1000;
              }

              .bold{
                  font-weight:bold;
              }
              .bb-p{
                border-bottom: 1px solid black;
                margin-bottom: 10px ;
              }
              .w-50 {
                  width: 50%;
              }
              table.grid{
                border-collapse: collapse;
                margin-right: 5px;
                margin-left: 5px;
              }
              table.grid>tbody>tr td {
                border: 0.5px solid black;
                text-align: center;
                padding: 2px;
              }
              .width-for-table{
                  width: 50%;
              }
              .text-center{
                text-align: center;
              }
              .p-1{
                padding : 5px;
              }
              .pl-1{
                padding-left: 23px;
              }
              .border-bot{
                border-bottom : 1px solid black;
              }
              .mt{
                margin-top:10px;
              }
              .mtl{
                margin-top:30px;
              }
              .margin{
                margin : 5px;
              }
              .pl-2{
                padding: 5px;
              }
            }`}
          </style>
          <div className="bold text-center p-1 ">
            MAGNUM CLOTHING PVT LTD - TRIM DEVELOPMENT SHEET - FDS
          </div>

          <div className="printrow mtl pl-2">
            <div className="printcolumn">
              <div className="fabric-text pl-1 ">{trim && trim.trimNumber}</div>
              <img
                width="100px"
                height="100px"
                src={UtilityService.fileUrl() + trim.trimImage}
                alt={trim.trimImage}
              />
            </div>
            <div className="printcolumn">
              <table>
                <tbody>
                  <tr>
                    <td className="label-text">Trim Category</td>
                    <td className="bold">{trim.trimCategory}</td>
                  </tr>
                  <tr>
                    <td className="label-text">Trim Descrption</td>
                    <td className="bold">{trim.description}</td>
                  </tr>
                  <tr>
                    <td className="label-text">Color</td>
                    <td className="bold">{trim.color}</td>
                  </tr>
                  <tr>
                    <td className="label-text">Quality</td>
                    <td className="bold">{trim.quality}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="printcolumn">
              <table>
                <tbody>
                  <tr>
                    <td className="label-text">Trim Ref No.</td>
                    <td className="bold">{trim.trimRef}</td>
                  </tr>
                  <tr>
                    <td className="label-text">Supplier Ref No.</td>
                    <td className="bold">{trim.supplierRef}</td>
                  </tr>
                  <tr>
                    <td className="label-text">Size</td>
                    <td className="bold">{`${trim.sizeNumber} - ${trim.size}`}</td>
                  </tr>
                  <tr>
                    <td className="label-text">Units</td>
                    <td className="bold">{trim.unit}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="printcolumn"></div>
          </div>
          {(trim.fullPackageData || trim.jobWorkData) && (
            <div className="printrow padding-for-heading blue">
              SUPPLIER PART
            </div>
          )}
          <div id="imgsupplier" className="printrow"></div>
          {trim.fullPackageData.length > 0 && (
            <Fragment>
              {trim.fullPackageData &&
                trim.fullPackageData.map((data, i) => {
                  return (
                    <Fragment>
                      {data && data.default && (
                        <Fragment>
                          <div className="printrow padding-for-heading blue">
                            FULL PACKAGE
                          </div>
                          <div className="printrow">
                            <div className="printcolumn">
                              <table className="grid">
                                <tbody>
                                  <tr>
                                    <td className="label-text">PURPOSE</td>
                                    <td className="label-text">DATE</td>
                                    <td className="label-text">SUPP NAME</td>
                                    <td className="label-text">SUPP REF</td>
                                    <td className="label-text">LT (DAYS)</td>
                                    <td className="label-text">WIDTH</td>
                                    <td className="label-text">$/₹</td>
                                    <td className="label-text">PRICE</td>
                                    <td className="label-text">UNITS</td>
                                    <td className="label-text">GST%</td>
                                    <td className="label-text">TRANS</td>
                                    <td className="label-text">TOTAL COST</td>
                                    <td className="label-text">DEFAULT</td>
                                  </tr>
                                  <tr>
                                    <td className="bold">
                                      {data.purposeLabel !== null
                                        ? data.purposeLabel
                                        : ""}
                                    </td>
                                    <td className="bold">
                                      {data.date !== null
                                        ? moment(data.date).format(
                                          "MMM Do YYYY"
                                        )
                                        : ""}
                                    </td>
                                    <td className="bold">
                                      {data.SupplierNameLabel !== null
                                        ? data.SupplierNameLabel
                                        : ""}
                                    </td>
                                    <td className="bold">
                                      {data.supplierRef !== null
                                        ? data.supplierRef
                                        : ""}
                                    </td>
                                    <td className="bold">
                                      {data.leadTime !== null
                                        ? data.leadTime
                                        : ""}
                                    </td>
                                    <td className="bold">
                                      {data.width !== null ? data.width : ""}
                                    </td>
                                    <td className="bold">
                                      {data.currency !== null
                                        ? data.currency === "rupee"
                                          ? "₹"
                                          : "$"
                                        : ""}
                                    </td>
                                    <td className="bold">
                                      {data.price !== null
                                        ? data.currency === "rupee"
                                          ? `₹${data.price}`
                                          : `$${data.price}`
                                        : ""}
                                    </td>
                                    <td className="bold">
                                      {data.MY !== null ? data.MY : ""}
                                    </td>
                                    <td className="bold">
                                      {data.GST !== null &&
                                        data.currency === "rupee"
                                        ? data.GST
                                        : "N/A"}
                                    </td>
                                    <td className="bold">
                                      {data.transport !== null &&
                                        data.currency === "rupee"
                                        ? data.transport
                                        : "N/A"}
                                    </td>
                                    <td className="bold">
                                      {data.totalCost !== null
                                        ? data.totalCost
                                        : ""}
                                    </td>
                                    <td className="bold">
                                      {data.default !== null
                                        ? data.default
                                          ? "YES"
                                          : "NO"
                                        : ""}
                                    </td>
                                  </tr>
                                  {data.MY === "gross" ? (
                                    <tr>
                                      <td>
                                        <span className="label-text">
                                          1 Gross
                                        </span>{" "}
                                        = 42 Pcs
                                      </td>
                                      <td className="label-text">
                                        <span className="label-text">
                                          Price/Pc
                                        </span>{" "}
                                        -
                                        {data.currencyData &&
                                          data.currencyData.priceMTS}
                                      </td>
                                    </tr>
                                  ) : null}
                                  <br />
                                  {data.currency === "dollar" && (
                                    <Fragment>
                                      <tr>
                                        <td className="label-text">
                                          SHIPMENT TERM
                                        </td>
                                        <td className="label-text">
                                          SHIPMENT MODE
                                        </td>
                                        <td className="label-text">
                                          PORT OF PICKUP
                                        </td>
                                        <td className="label-text">MOQ</td>
                                        <td className="label-text">PL Code</td>
                                        <td className="label-text">
                                          MATERIAL ORIGIN
                                        </td>
                                          <td className="label-text">
                                          CONV. TO INR
                                        </td>
                                        <td className="label-text">
                                          FREIGHT COSTS ₹
                                        </td>
                                        <td className="label-text">
                                          CLEARANCE ₹
                                        </td>
                                        <td className="label-text">DUTY %</td>
                                        
                                      </tr>
                                      <tr>
                                        <td className="bold">
                                          {data.currencyData &&
                                            data.currencyData.shipmentTerm !==
                                            null &&
                                            data.currencyData.shipmentTerm !==
                                            undefined
                                            ? data.currencyData.shipmentTerm
                                            : ""}
                                        </td>
                                        <td className="bold">
                                          {data.currencyData &&
                                            data.currencyData.shipmentMode !==
                                            null &&
                                            data.currencyData.shipmentMode !==
                                            undefined
                                            ? data.currencyData.shipmentMode
                                            : ""}
                                        </td>
                                        <td className="bold">
                                          {data.currencyData &&
                                            data.currencyData.portOfPickup !==
                                            null &&
                                            data.currencyData.portOfPickup !==
                                            undefined
                                            ? data.currencyData.portOfPickup
                                            : ""}
                                        </td>
                                         <td className="bold">
                                          {data.moq &&
                                            data.moq !== null &&
                                            data.moq !== undefined
                                            ? data.moq
                                            : ""}
                                        </td>
                                        <td className="bold">
                                          {data.plCode &&
                                            data.plCode !== null &&
                                            data.plCode !== undefined
                                            ? data.plCode
                                            : ""}
                                        </td>
                                        <td className="bold">
                                          {data.materialOrigin &&
                                            data.materialOrigin !== null &&
                                            data.materialOrigin !== undefined
                                            ? data.materialOrigin
                                            : ""}
                                        </td>
                                        <td className="bold">
                                          {data.currencyData &&
                                            data.currencyData.conversionToINR !==
                                            null &&
                                            data.currencyData.conversionToINR !==
                                            undefined
                                            ? data.currencyData.conversionToINR
                                            : ""}
                                        </td>
                                        <td className="bold">
                                          {data.currencyData &&
                                            data.currencyData.freightCosts !==
                                            null &&
                                            data.currencyData.freightCosts !==
                                            undefined
                                            ? data.currencyData.freightCosts
                                            : ""}
                                        </td>
                                        <td className="bold">
                                          {data.currencyData &&
                                            data.currencyData.clearance !==
                                            null &&
                                            data.currencyData.clearance !==
                                            undefined
                                            ? data.currencyData.clearance
                                            : ""}
                                        </td>
                                        <td className="bold">
                                          {data.currencyData &&
                                            data.currencyData.duty !== null &&
                                            data.currencyData.duty !== undefined
                                            ? data.currencyData.duty
                                            : ""}
                                        </td>
                                      </tr>
                                    </Fragment>
                                  )}
                                  {data.currency !== "dollar" && (<Fragment>
                                    <tr>
                                      <td colSpan="13">
                                        <div className="printrow">
                                          <div className="printcolumn box-item">
                                            <div className="label-text">MOQ</div>
                                            <div className="bold">{data.moq || ""}</div>
                                          </div>
                                          <div className="printcolumn box-item">
                                            <div className="label-text">PL Code</div>
                                            <div className="bold">{data.plCode || ""}</div>
                                          </div>
                                          <div className="printcolumn">
                                            <div className="label-text">MATERIAL ORIGIN</div>
                                            <div className="bold">{data.materialOrigin || ""}</div>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  </Fragment>)}
                                </tbody>
                              </table>
                              <div className="printrow padding-for-heading blue">
                                FULL PACKAGE - SPECIAL COMMENTS
                              </div>
                              <div className="printrow">
                                <div className="specialComments">
                                  {data.specialComments
                                    .split("\n")
                                    .map(comment => {
                                      return <p>{comment}</p>;
                                    })}
                                </div>
                              </div>
                            </div>
                          </div>
                        </Fragment>
                      )}
                    </Fragment>
                  );
                })}
            </Fragment>
          )}
          {trim.jobWorkData.length > 0 && (
            <Fragment>
              {trim &&
                trim.jobWorkData &&
                trim.jobWorkData.length > 0 &&
                trim.jobWorkData.map((data, i) => {
                  return (
                    <Fragment>
                      {data && data.default && (
                        <Fragment>
                          <div className="printrow padding-for-heading blue">
                            JOB WORK
                          </div>
                          <div className="printrow">
                            <div className="printcolumn">
                              <table className="grid">
                                <tbody>
                                  <tr>
                                    <td className="label-text">
                                      OPTION - {data.purposeLabel}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="label-text">PROCESS</td>
                                    <td className="label-text">DATE</td>
                                    <td className="label-text">
                                      SUPPLIER NAME
                                    </td>
                                    <td className="label-text">LT (DAYS)</td>
                                    <td className="label-text">WIDTH</td>
                                    <td className="label-text">$/₹</td>
                                    <td className="label-text">PRICE</td>
                                    <td className="label-text">VL%</td>
                                    <td className="label-text">COST</td>
                                  </tr>
                                  {data.rowData.map((row, index) => {
                                    return (
                                      <Fragment>
                                        {row.process.length > 0 && (
                                          <tr>
                                            <td className="bold">
                                              {row.process}
                                            </td>
                                            <td className="bold">
                                              {row.date !== null ?
                                                moment(row.date).format(
                                                  "MMM Do YYYY"
                                                ) : ""}
                                            </td>
                                            <td className="bold">
                                              {row.SupplierNameLabel}
                                            </td>
                                            <td className="bold">
                                              {row.leadTime}
                                            </td>
                                            <td className="bold">
                                              {row.width}
                                            </td>
                                            <td className="bold">
                                              {row.currency === "dollar"
                                                ? "$"
                                                : "₹"}
                                            </td>
                                            <td className="bold">
                                              {row.price}
                                            </td>
                                            <td className="bold">{row.vl}</td>
                                            <td className="bold">{row.cost}</td>
                                          </tr>
                                        )}
                                      </Fragment>
                                    );
                                  })}
                                  <tr>
                                    <td className="label-text"></td>
                                    <td className="label-text"></td>
                                    <td className="label-text"></td>
                                    <td className="label-text"></td>
                                    <td className="label-text"></td>
                                    <td className="label-text"></td>
                                    <td className="label-text">GST</td>
                                    <td className="bold">{data.GST}%</td>
                                    <td className="bold">
                                      {data.totalCost - data.transport}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="label-text"></td>
                                    <td className="label-text"></td>
                                    <td className="label-text"></td>
                                    <td className="label-text"></td>
                                    <td className="label-text"></td>
                                    <td className="label-text"></td>
                                    <td className="label-text">Transport%</td>
                                    <td className="bold">{data.transport * 100}%</td>
                                    <td className="bold">{data.totalCost}</td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <span className="label-text">MOQ</span> -{" "}
                                      <span className="bold">{data.moq}</span>
                                    </td>
                                    <td>
                                      <span className="label-text">
                                        {" "}
                                        Total Lead Time
                                      </span>{" "}
                                      -{" "}
                                      <span className="bold">
                                        {data.totalLeadTime}
                                      </span>
                                    </td>
                                    <td>
                                      <span className="label-text">
                                        Finished Width
                                      </span>{" "}
                                      -{" "}
                                      <span className="bold">
                                        {data.finishedWidth}
                                      </span>
                                    </td>
                                    <td>
                                      <span className="label-text">
                                        Cuttable Width
                                      </span>{" "}
                                      -
                                      <span className="bold">
                                        {" "}
                                        {data.cuttableWidth}
                                      </span>
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td className="label-text">Total Cost</td>
                                    <td className="bold">{data.totalCost}</td>
                                  </tr>
                                </tbody>
                              </table>
                              <div className="printrow padding-for-heading blue">
                                JOB WORK - SPECIAL COMMENTS
                              </div>
                              <div className="printrow">
                                <div className="specialComments">
                                  {data.specialComments
                                    .split("\n")
                                    .map(comment => {
                                      return <p>{comment}</p>;
                                    })}
                                </div>
                              </div>
                            </div>
                          </div>
                        </Fragment>
                      )}
                    </Fragment>
                  );
                })}
            </Fragment>
          )}

          <div className="printrow padding-for-heading blue">
            GENERAL SPECIAL COMMENTS
          </div>
          <div className="printrow">
            <div className="specialComments">
              {trim.comments && trim.comments.split("\n").map(comment => {
                return <p>{comment}</p>;
              })}
            </div>
          </div>
          <div className="printrow padding-for-heading blue">IMAGES</div>
          <div className="printrow">
            {trim.refImages &&
              trim.refImages.map(data => {
                return (
                  <div className="margin">
                    <img
                      width="50px"
                      height="50px"
                      src={UtilityService.fileUrl() + data.path}
                    />
                  </div>
                );
              })}
          </div>

          {/* {trim.fullPackageData && (
            <div className="printrow">
              <table>
                <thead>
                  <tr>
                    <th className="fontSize12" width="9%">
                      Purpose
                    </th>
                    <th className="fontSize12" width="12%">
                      Date
                    </th>
                    <th className="fontSize12" width="15%">
                      Supplier Name
                    </th>
                    <th className="fontSize12" width="8%">
                      Supplier Ref
                    </th>
                    <th className="fontSize12" width="6%">
                      LT
                      <br />
                      (days)
                    </th>
                    <th className="fontSize12" width="8%">
                      Width
                    </th>
                    <th className="fontSize12" width="6%">
                      $/₹
                    </th>
                    <th className="fontSize12" width="11%">
                      Price
                    </th>
                    <th className="fontSize12" width="7%">
                      Units
                    </th>
                    <th className="fontSize12" width="5%">
                      GST%
                    </th>
                    <th className="fontSize12" width="5%">
                      Trans
                    </th>
                    <th className="fontSize12" width="8%">
                      Total cost
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{fullPackageData.purpose}</td>
                    <td>{fullPackageData.date}</td>
                    <td>{fullPackageData.supplierName}</td>
                    <td>
                      <span
                        style={{
                          whiteSpace: "nowrap",
                          width: "30px",
                          overflow: "hidden",
                          textOverflow: "---",
                          display: "block"
                        }}
                      >
                        {fullPackageData.supplierRef}
                      </span>
                    </td>
                    <td>{fullPackageData.leadTime}</td>
                    <td>{fullPackageData.width}</td>
                    <td>
                      {(fullPackageData.currency &&
                        fullPackageData.currency === "rupee" &&
                        "₹") ||
                        "$"}
                    </td>
                    <td>{fullPackageData.price}</td>
                    <td>{fullPackageData.MY}</td>
                    <td>{fullPackageData.GST}</td>
                    <td>{fullPackageData.transport}</td>
                    <td>{fullPackageData.totalCost}</td>
                  </tr>
                </tbody>
              </table>
              {fullPackageData.currency === "doller" && (
                <div className="col-md-6">
                  <table class="table">
                    <tbody>
                      <tr>
                        <td className="border-0">Price $ </td>
                        <td className="border-0" />
                        <td className="border-0">{fullPackageData.price}</td>
                        <td className="border-0">{fullPackageData.MY}</td>
                      </tr>
                      <tr className="border-0">
                        <td className="border-0" />
                        <td className="border-0" />
                        <td className="border-0">
                          {fullPackageData.currencyData.priceMTS}
                        </td>
                        <td className="border-0">
                          {fullPackageData.MY === "gross"
                            ? "PER PC"
                            : fullPackageData.MY}
                        </td>
                      </tr>
                      <tr>
                        <td className="border-0">Convertion to INR</td>
                        <td className="border-0" />
                        <td className="border-0">
                          {fullPackageData.currencyData.conversionToINR}
                        </td>
                      </tr>
                      <tr className="border-0">
                        <td className="border-0">Shipment term</td>
                        <td className="border-0" />
                        <td className="border-0">
                          {fullPackageData.currencyData.shipmentTerm}
                        </td>
                        <td className="border-0" />
                      </tr>
                      <tr className="border-0">
                        <td className="border-0">Ship Mode</td>
                        <td className="border-0" />

                        <td className="border-0">
                          {fullPackageData.currencyData.shipmentMode}
                        </td>
                        <td className="border-0" />
                      </tr>
                      <tr className="border-0">
                        <td className="border-0">Port of Pick up</td>
                        <td className="border-0" />

                        <td className="border-0">
                          {fullPackageData.currencyData.portOfPickup}
                        </td>
                        <td className="border-0" />
                      </tr>
                      <tr className="border-0">
                        <td className="border-0">Freight costs ₹</td>
                        <td className="border-0" />

                        <td className="border-0">
                          {fullPackageData.currencyData.freightCosts}
                        </td>
                        <td className="border-0" />
                      </tr>
                      <tr className="border-0">
                        <td className="border-0">Clearance ₹</td>
                        <td className="border-0" />
                        <td className="border-0">
                          {fullPackageData.currencyData.clearance}
                        </td>
                        <td className="border-0" />
                      </tr>
                      <tr className="border-0">
                        <td className="border-0">Duty %</td>
                        <td className="border-0" />

                        <td className="border-0">
                          {fullPackageData.currencyData.duty}
                        </td>
                        <td className="border-0" />
                      </tr>
                      <tr className="border-0">
                        <td className="border-0">Total Trim Cost</td>
                        <td className="border-0" />
                        <td className="thicker border-0">
                          ₹ {fullPackageData.totalCost}
                        </td>
                        <td className="border-0" />
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )} */}
          {/* {trim.jobWork && (
            <div className="printrow">
              <table>
                <thead>
                  <tr>
                    <th className="fontSize12" width="9%">
                      Purpose
                    </th>
                    <th className="fontSize12" width="12%">
                      Date
                    </th>
                    <th className="fontSize12" width="15%">
                      Supplier Name
                    </th>
                    <th className="fontSize12" width="8%">
                      Supplier Ref
                    </th>
                    <th className="fontSize12" width="6%">
                      LT
                      <br />
                      (days)
                    </th>
                    <th className="fontSize12" width="8%">
                      Width
                    </th>
                    <th className="fontSize12" width="6%">
                      $/₹
                    </th>
                    <th className="fontSize12" width="11%">
                      Price
                    </th>
                    <th className="fontSize12" width="7%">
                      Units
                    </th>
                    <th className="fontSize12" width="5%">
                      GST%
                    </th>
                    <th className="fontSize12" width="5%">
                      Trans
                    </th>
                    <th className="fontSize12" width="8%">
                      Total cost
                    </th>
                    <th className="fontSize12" width="5%">
                      Default
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
          )} */}
        </div>
      </Fragment>
    );
  }
}

export default PrintDevelopmentTrim;


// WEBPACK FOOTER //
// ./src/pages/Trim/print.js